import { VFC } from 'react'
import { Link } from 'src/elements/Link'
import { Article } from 'src/models/Article'
import { _membertopborder, _menuhover, truewhite } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { membersArticlePage } from 'src/utils/routes'
import styled from 'styled-components'
import { Section } from './Section'

type ArticlesProps = {
  articles: Article[]
}
export const Articles: VFC<ArticlesProps> = ({ articles }) => (
  <Div>
    <Section title="運営からのお知らせ">
      <ArticlesDiv>
        {articles.map(({ id, title, createdAt }) => (
          <StyledArticle key={id}>
            <h3>
              <Link href={membersArticlePage(id)}>{title}</Link>
            </h3>
            <p>{createdAt.format('YYYY/MM/DD')}</p>
          </StyledArticle>
        ))}
      </ArticlesDiv>
    </Section>
  </Div>
)

const Div = styled.div`
  @media screen and (max-width: 960px) {
    display: none;
  }
`
const ArticlesDiv = styled.div`
  min-height: 150px;
  max-height: 300px;
  max-width: 640px;
  padding: 20px;
  margin: 40px auto 0;
  overflow-y: auto;

  border-radius: 5px;
  border: 1px solid ${_membertopborder};
  background-color: ${truewhite};
`
const StyledArticle = styled.article`
  padding: 30px 0;
  border-bottom: 1px solid ${_membertopborder};
  :first-child {
    padding-top: 15px;
  }
  h3 {
    font-size: 18px;
    font-weight: ${fontWeightBold};
    margin-bottom: 8px;
  }
  a {
    :hover {
      color: ${_menuhover};
      text-decoration: underline;
    }
  }
`
